import Section from '@components/atoms/Section';
import { FC } from 'react';
import styled from 'styled-components';
import RichTextWrapper from './RichTextWrapper';

const Content = styled(Section)`
  max-width: 960px;
  padding-bottom: 64px;

  @media screen and (max-width: 768px) {
    padding: 20px 20px 64px;
  }
`;

const RichTextSection: FC<{ pastel?: boolean }> = ({ children, pastel }) => (
  <Content pastel={pastel}>
    <RichTextWrapper>{children}</RichTextWrapper>
  </Content>
);

export default RichTextSection;
